import React from 'react';

const RoundedBox = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="bg-white px-3 py-3 border border-grey rounded-xl sm:py-6 sm:px-6">
      {children}
    </div>
  );
};

export default RoundedBox;
